import React, { Component } from "react";
import "./Footer.css";

class Footer extends Component {
  render() {
    
    return (<div className="Mainfooter">
        
        <p>Brandon Harris @ 2019</p>
      
      </div>
    );
  }
}

export default Footer;